import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import EditBoxProduct from './EditBoxProduct';
import EditBoxPersona from './EditBoxPersona';
import classes from './EditBox.module.css';

const EditBox = (props) => {
  const { connector, title, id, children, color, personas, products } = props;

  const droppableId = connector
    ? `droppable-${connector}-${title}-${id}`
    : `droppable-${title}-${id}`;

  const style = children ? {} : { minHeight: '15px' };
  // const ctr = connector ? connector : title;
  // const idx = index.toString().split('').pop();
  // const editButton = (
  //   <div
  //     className="edit-box-button"
  //     data-milestone={title}
  //     data-connector={ctr}
  //     data-index={idx}
  //     onClick={onEditClick}
  //     style={{ cursor: 'pointer' }}
  //   >
  //     <Icon
  //       data-milestone={title}
  //       assistiveText={{ label: 'Edit' }}
  //       category="action"
  //       name="edit"
  //       size="x-small"
  //     />
  //   </div>
  // );

  return (
    <div
      className={
        connector
          ? [
              classes.editBoxOuterContainer,
              classes.milestoneConnectorContainer,
            ].join(' ')
          : classes.editBoxOuterContainer
      }
    >
      <div className={['slds-text-title_caps', classes.editBoxTitle].join(' ')}>
        {title}
      </div>
      <div
        className={[
          'slds-grid',
          'slds-gutters',
          'slds-grid_vertical-align-center',
          classes.editBoxTitle,
        ].join(' ')}
      >
        <div
          className={[
            'slds-col',
            'slds-size_11-of-12',
            classes.editBoxContainer,
          ].join(' ')}
          style={{ borderColor: color }}
        >
          <Droppable droppableId={droppableId}>
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={style}
              >
                {provided.placeholder}

                {children}

                {/*PRODUCTS*/}
                {products.map((product, index) =>
                  product ? (
                    <EditBoxProduct
                      product={product}
                      index={index}
                      connector={connector}
                      title={title}
                    />
                  ) : null
                )}

                {/*PERSONAS*/}
                {personas.map((persona, index) =>
                  persona ? (
                    <EditBoxPersona
                      persona={persona}
                      index={index}
                      connector={connector}
                      title={title}
                    />
                  ) : null
                )}
              </div>
            )}
          </Droppable>
        </div>
        <div className="slds-col slds-size-1-of-12">{/**editButton*/}</div>
      </div>
    </div>
  );
};

export default EditBox;
